





















import Vue, { VueConstructor } from 'vue';
import { AxiosResponse, AxiosError } from 'axios';
import services from '../../../../services';
import { CaseInformation, AttendanceInformation } from '../../../../models/api-client';
import { CaseVm } from '../viewModel';
import mapper from '../mappers';
import { PageTitle } from '@/common/components';
import CloseCasesTable from '@/views/Customer/Cases/Close/components/CloseCasesTable.vue';
import { ToastMessage } from '@/plugins/toast/models/message';
import { ErrorStatesOptions } from '@/models/errorEntities';
import lang from '../../../../common/lang/de';

const { UserService } = services;

export default (Vue as VueConstructor<Vue & {
  $refs: {},
}>).extend({
  name: 'CloseCases',
  components: {
    PageTitle,
    CloseCasesTable,
  },
  data() {
    return {
      isMobile: false as boolean,
      expand: false as boolean,
      userId: '' as string,
      title: 'Close Cases' as string,
      headers: [
        { text: 'Beschreibung', value: 'caseDescriptionShort' },
        { text: 'Geschlossen am', value: 'caseClosed' },
        { text: 'Produkt', value: 'caseGroup1' },
        { text: 'Status', value: 'caStDescription' },
        { text: 'Zuständig', value: 'staffSignature' },
        { text: 'Eröffnet am', value: 'createDate' },
      ],
      subHeaders: [
        { text: 'Mitarbeitername', value: 'staffSignature' },
        { text: 'Beschreibung', value: 'caTcDescription' },
        { text: 'Datum (Startzeit)', value: 'caTcStart' },
        { text: 'Uhrzeit (Startzeit)', value: 'hour' },
        { text: 'Endezeit', value: 'caTcEnd' },
        { text: 'Dauer', value: 'caTcHours' },
        { text: 'Freiminuten', value: 'caTcHoursFree' },
      ],
      data: [] as CaseVm[],
    };
  },
  created() {
    this.userId = this.$route.params.id;
  },
  methods: {
    goTo() {
      this.$router.push({
        name: 'Welcome',
        params: {
          id: this.userId,
        },
      });
    },
    onResize() {
      if (window.innerWidth < 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    getAllCloseCases() {
      this.$loader.show();
      UserService.getAllCloseCases(this.$store.getters['user/getDebtorNumber']).then((result: AxiosResponse<CaseInformation[]>) => {
        this.data = mapper.mapCaseListDtoToCaseListCloseVm(result.data);
        setTimeout(() => {
          this.$loader.hide();
        }, 500);
      }).catch((err: AxiosError) => {
        if ((err.response !== undefined) && (err.response.status === 401 || err.response.status === 500)) {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.NotAuthorized);
          this.$router.push({ name: 'Index' });
        } else {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.UnexpectedError);
        }
      });
    },
    expandAttendanceCloseCase(props: any) {
      if (props.expanded) {
        UserService.getAttendanceCase(props.item.caseId).then((result: AxiosResponse<AttendanceInformation[]>) => {
          const index = this.data.findIndex(d => d.caseId === props.item.caseId);
          this.data[index].attendance = mapper.mapAttendanceListDtoToAttendanceListVm(result.data);
        }).catch((err: AxiosError) => {
          if ((err.response !== undefined) && (err.response.status === 401 || err.response.status === 500)) {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.NotAuthorized);
            this.$router.push({ name: 'Index' });
          } else {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.UnexpectedError);
          }
        });
      }
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
  },
});
